import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FiltersPagination from "../../../components/elements/FiltersPagination";
import DataTableElement from "../../../components/elements/DataTableElement";
import AddUpServiceOrder from "../AddUpServiceOrder";
import { Columns } from "./Columns";
import { reportResource, servicesOrderResource } from "../../../helpers/configRoutes/backend_helper";
import { reset_service, update_service } from "../../../store/serviceOrders/action";

const ServiceRequest = () => {
    const dispatch = useDispatch();
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1 });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [tableLoad, setTableLoad] = useState({ show: false });
    const [serviceRequestItem, setServiceRequestItem] = useState([]);
    const [modal, setModal] = useState({ show: false });

    const openCreateServiceOrder = (serviceRequest) => {
        dispatch(reset_service());
        dispatch(update_service({
            id: '',
            internalId: '',
            description: serviceRequest.description || '',
            creation_date: '',
            due_date: '',
            estimated_cost: '',
            real_cost: '',
            status_id: '',
            status: {
                id: '',
                name: '',
                color: '',
            },
            supplier_id: '',
            supplier: {
                id: '',
                name: '',
            },
            trailer_id: serviceRequest.trailer?.id || '',
            trailer: serviceRequest.trailer || {
                id: '',
                number: '',
                name: '',
            },
            truck_id: serviceRequest.truck?.id || '',
            truck: serviceRequest.truck || {
                id: '',
                number: '',
                name: '',
            },
            service_request_id: serviceRequest.id,
            service_request: serviceRequest,
            mileage_control: 0,
            current_mileage_truck: 0,
            miles_interval_truck: 0,
            current_mileage_trailer: 0,
            miles_interval_trailer: 0,
        }));

        setModal({
            show: true,
            title: `Create service order from request #${serviceRequest.id}`,
        });
    };

    const openViewServiceOrder = async (serviceRequest) => {
        if (!serviceRequest.service_order_id) {
            return;
        }

        setTableLoad({ show: true });

        try {
            const response = await servicesOrderResource('show', {}, serviceRequest.service_order_id);
            if (response?.status && response?.service) {
                dispatch(update_service(response.service));
                setModal({
                    show: true,
                    title: `Service order ${response.service.internalId}`,
                });
            }
        } catch (error) {
            console.error("Error fetching linked service order:", error);
        }

        setTableLoad({ show: false });
    };

    const cols = Columns(openCreateServiceOrder, openViewServiceOrder);

    useEffect(() => {
        const fetchServiceRequests = async () => {
            setTableLoad({ show: true });
            try {
                const response = await reportResource("get", { params: filters });
                setServiceRequestItem(response.reports || []);
                setMeta(response.meta || { total: 0, current_page: 1 });
            } catch (error) {
                console.error("Error fetching service request:", error);
            }
            setTableLoad({ show: false });
        };

        fetchServiceRequests();
    }, [filters]);

    return (
        <>
            <div className="min-h-screen bg-cs-surface">
                <div className="px-4 md:px-6 py-6 max-w-auto mx-auto">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                        <div>
                            <h1 className="text-2xl font-semibold text-cs-dark">
                                Service request
                            </h1>
                            <p className="text-sm text-cs-muted mt-1">
                                Review reported failures and convert them into maintenance orders.
                            </p>
                        </div>

                        <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                            Total requests:{" "}
                            <span className="font-semibold text-cs-dark">
                                {meta?.total ?? serviceRequestItem.length}
                            </span>
                        </div>
                    </div>

                    <div className="bg-cs-bg border border-cs-border rounded-2xl shadow-sm px-2 py-2">
                        <FiltersPagination
                            showFilters={false}
                            filters={filters}
                            setFilters={setFilters}
                            meta={meta}
                            statusModel="Settlement"
                        >
                            <DataTableElement
                                columns={cols}
                                items={serviceRequestItem}
                                tableLoad={tableLoad}
                            />
                        </FiltersPagination>
                    </div>
                </div>
            </div>

            {modal.show && (
                <AddUpServiceOrder
                    modal={modal}
                    setModal={setModal}
                    filters={filters}
                    setFilters={setFilters}
                />
            )}
        </>
    )
}

export default ServiceRequest;
